import type { DeletionRequestStatus } from "../types/types.ts"

export const accountDeletionSliceName = "accountDeletion"

export const STATUS_COLOR_MAP: Record<DeletionRequestStatus, string> = {
  pending: "gold",
  // The decision is made but anonymization is still running — must not read as
  // a finished `completed`.
  processing: "processing",
  completed: "green",
  rejected: "default",
  cancelled: "default"
}

// Finalize normally lands in well under a second; these bounds only exist so a
// genuinely broken worker stops the polling instead of spinning forever.
export const RETRY_POLL_ATTEMPTS = 4
export const RETRY_POLL_INTERVAL_MS = 1200

// Thresholds the SLA badge colours on. The backend's 5-day escalation is not
// mirrored here — the badge reads `escalation_reminded_at` off the row instead.
export const SLA_BUSINESS_DAYS = {
  initialReview: 3,
  finalTarget: 7
}
